<ce-container>
    <ce-empty-state type="unauthorized" actionLabel="Go to login" actionHref="auth/login">
        <h1 ce-empty-state-title>You are logging out</h1>
        <p ce-empty-state-description>
            We are signing you out of ChargEye.
            <span class="flex u-spacing-lg-mt"> Thank you for using ChargEye. You will be redirected shortly, or you can go back to the login page manually. </span>
        </p>
    </ce-empty-state>
</ce-container>
